export default __webpack_public_path__ + "static/ai-solutions-with-roadmap2--mobile-afaa68919e5ee396cc4d4555f9e7bf64.jpg";